import React from 'react';

import SelectInput from '../../../select_input';

class CouponSelector extends React.Component {

  render () {
    if (! this.props.types[this.props.type].coupon_enabled) return <div></div>;

    let noCoupon = [{name: 'No discount', value: 'nil'}];

    let couponOptions = this.props.coupons.map((coupon) => {
      return {name: `${coupon.display} (${coupon.id})`, value: coupon.id};
    });

    let coupons = noCoupon.concat(_.sortBy(couponOptions, 'name'));

    return (
      <SelectInput name="billing_subscription[coupon]"
                   options={coupons}
                   label="Coupon"
                   defaultValue={this.props.coupon ? this.props.coupon.id : 'nil'}/>
    )
  }

}

module.exports = CouponSelector;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/admin/billing_subscriptions/coupon_selector.jsx